import { call, put, takeEvery } from "redux-saga/effects"
import {
  GET_NOTIFICATIONS_EMAIL,
  DELETE_NOTIFICATION_EMAIL,
  EDIT_NOTIFICATION_EMAIL,
  GET_AREA,
  SAVE_NOTIFICATION_EMAIL,
  SEND_EMAIL,
} from "./actionTypes"

import {
  getNotificationsEmailSuccess,
  getNotificationsEmailFail,
  deleteNotificationEmailSuccess,
  deleteNotificationEmailFail,
  editNotificationEmailSuccess,
  editNotificationEmailFail,
  getStatusOrderSuccess,
  getStatusOrderFail,
  saveNotificationEmailSuccess,
  saveNotificationEmailFail,
  sendNotificationEmailFail,
  sendNotificationEmailSuccess,
} from "./actions"

import serviceNotificationEmail from "../../api/notificationsEmail.service"
import i18n from "i18next"
import showToast from "../../components/Common/viewNotification"

function* fetchNotificationEmail({ payload: filter }) {
  try {
    const response = yield serviceNotificationEmail.getNotificationsEmail(
      filter
    )
    const error = response?.response?.data?.error
    if (error) yield put(getNotificationsEmailFail(error))
    else yield put(getNotificationsEmailSuccess(response))
  } catch (error) {
    yield put(getNotificationsEmailFail(error))
  }
}

function* fetchStatusOrder() {
  try {
    const response = yield serviceNotificationEmail.getStatusOrder()
    const error = response?.response?.data?.error
    if (error) {
      yield put(getStatusOrderFail(error))
    } else {
      yield put(getStatusOrderSuccess(response.data))
    }
  } catch (error) {
    yield put(getStatusOrderFail(error))
  }
}

function* saveNotificationEmail({ payload: notification }) {
  try {
    const response = yield call(
      serviceNotificationEmail.saveNotificationEmail,
      notification
    )
    const responseArray = Array.isArray(response) ? response : [response]
    for (const item of responseArray) {
      const error = item.response?.data?.error
      if (error) {
        yield put(saveNotificationEmailFail(error))
      } else {
        yield put(saveNotificationEmailSuccess(response))
        showToast(i18n.t("global:msgSuccessSaveList"), "success")
      }
    }
  } catch (error) {
    yield put(saveNotificationEmailFail(error))
  }
}

function* onDeleteNotificationEmail({ payload: notificationList }) {
  try {
    const response = yield call(
      serviceNotificationEmail.deleteNotificationEmail,
      notificationList
    )
    const error = response?.response?.data?.error
    if (error) {
      yield put(deleteNotificationEmailFail(error))
    } else {
      yield put(deleteNotificationEmailSuccess(response))
      showToast(i18n.t("global:msgSuccessSaveList"), "success")
    }
  } catch (error) {
    yield put(deleteNotificationEmailFail(error))
  }
}
function* onEditNotificationEmail({ payload: notification }) {
  try {
    const response = yield call(
      serviceNotificationEmail.editNotificationEmail,
      notification
    )
    const error = response?.response?.data?.error
    if (error) {
      yield put(editNotificationEmailFail(error))
    } else {
      yield put(editNotificationEmailSuccess(response))
      showToast(i18n.t("global:msgSuccessSaveList"), "success")
    }
  } catch (error) {
    yield put(editNotificationEmailFail(error))
  }
}
function* sendNotificationEmail({ payload: notification }) {
  try {
    const response = yield call(
      serviceNotificationEmail.sendNotificationEmail,
      notification
    )
    const error = response?.response?.data?.error
    if (error) {
      yield put(sendNotificationEmailFail(error))
    } else {
      yield put(sendNotificationEmailSuccess(response.data))
    }
  } catch (error) {
    yield put(sendNotificationEmailFail(error))
  }
}
function* customersSaga() {
  yield takeEvery(GET_NOTIFICATIONS_EMAIL, fetchNotificationEmail)
  yield takeEvery(DELETE_NOTIFICATION_EMAIL, onDeleteNotificationEmail)
  yield takeEvery(EDIT_NOTIFICATION_EMAIL, onEditNotificationEmail)
  yield takeEvery(GET_AREA, fetchStatusOrder)
  yield takeEvery(SAVE_NOTIFICATION_EMAIL, saveNotificationEmail)
  yield takeEvery(SEND_EMAIL, sendNotificationEmail)
}

export default customersSaga
